export enum TestletType {
  Symbols,
  SimilarWords,
  NumberRecall,
  PictureCompletion,
  FakeWords,
  MissingNumbers,
  Objects,
  ShapesAndColors,
}
